import { onMounted, onUnmounted, ref } from "vue";

let isListenerAdded = false;
const isDeveloperMode = ref(false);

export default function useDeveloperMode() {
  const handleKeydown = (event: KeyboardEvent) => {
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "k") {
      event.preventDefault(); // Prevents default browser behavior
      isDeveloperMode.value = !isDeveloperMode.value;
    }
  };

  onMounted(() => {
    if (!isListenerAdded) {
      window.addEventListener("keydown", handleKeydown);
      isListenerAdded = true;
    }
  });

  onUnmounted(() => {
    window.removeEventListener("keydown", handleKeydown);
    isListenerAdded = false;
  });

  return { isDeveloperMode };
}
